import React from 'react';
import { Card, Col, Flex, Row, Statistic } from 'antd';
import RangePicker from 'components/date-range-picker';
import Orders from './Orders';
import TopProductInCart from './TopProductInCart';

const DashboardDesktop = ({ viewModel }) => {
  const {
    data,
    onDateRangeFilterChange,
    rangePickerPresets,
    rangePickerValue,
  } = viewModel;

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Flex justify='flex-end'>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <RangePicker
              format={'DD/MM/YY'}
              presets={rangePickerPresets}
              value={rangePickerValue}
              onChange={onDateRangeFilterChange}
            />
          </div>
        </Flex>
      </Col>

      <Col span={8}>
        <Card>
          <Statistic title="Lượt xem" value={data.views} />
        </Card>
      </Col>

      <Col span={8}>
        <Card>
          <Statistic title="Đơn hàng" value={data.order_count} />
        </Card>
      </Col>

      <Col span={8}>
        <Card>
          <Statistic title="Doanh số" value={data.order_amount} />
        </Card>
      </Col>

      <Col span={12}>
        <Card title="Đơn hàng gần đây" size='small'>
          <Orders></Orders>
        </Card>
      </Col>

      <Col span={12}>
        <Card title="Top sản phẩm bán được " size='small'>
          <TopProductInCart></TopProductInCart>
        </Card>
      </Col>
    </Row>
  );
};

export default DashboardDesktop;
